require('./bootstrap');
require('../../node_modules/bootstrap/dist/js/bootstrap.bundle');
require('./auth');
